import { Box } from '@mui/system';
import { ReactElement, memo } from 'react';

export interface HeaderLayoutProps {
  headerBar?: ReactElement;
  sessionStatus?: ReactElement;
}

export const HeaderLayout = memo(function HeaderLayout({ headerBar, sessionStatus }: HeaderLayoutProps): ReactElement {
  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      {headerBar}
      {sessionStatus}
    </Box>
  );
});
